import { render, staticRenderFns } from "./signinComponent.vue?vue&type=template&id=57203692&scoped=true"
import script from "./signinComponent.vue?vue&type=script&lang=js"
export * from "./signinComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57203692",
  null
  
)

export default component.exports